<template>
    <div>
<!--      <header-component></header-component>-->
      <div class="job-wanted-search">
        <el-input style="width: 800px" placeholder="搜索职位、公司" v-model="searchKeyWord" class="input-with-select" @keyup.enter.native="searchJobs">
          <el-button slot="append" icon="el-icon-search" @click="searchJobs"></el-button>
        </el-input>
        <div class="filter-tool">
          <div class="filter-item" v-for="(item, index) of filterParams" :key="index" :title="item.name">
            <el-dropdown placement="bottom-start" @command="filterWithParams">
            <span class="el-dropdown-link" v-if="!item.model">
              {{item.name}}<i class="el-icon-caret-bottom"></i>
            </span>
            <span class="el-dropdown-link" v-else>
              <el-tag effect="dark" size="mini" closable @close="deleteFilterParam(item)" :disable-transitions="true">{{item.model.content}}</el-tag><i class="el-icon-caret-bottom"></i>
            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(filterItem, filterItemIndex) of item.filterList"
                  :key="filterItemIndex"
                  :command="{item, filterItem}"
                  @click="item.model = filterItem">
                  {{filterItem.content}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="filter-item clear-filter-params" @click="clearFilterParams()">清空筛选条件</div>
        </div>
      </div>
      <br/>
      <div class="job-wanted-content" v-if="jobsData.length > 0">
        <div class="job-wanted-cards" v-for="(item, index) of jobsData" :key="index" @click="goJobDetailPage(item)">
          <el-card class="box-card">
            <div class="card-top">
              <div class="card-left">
                <span class="job-name-city">{{item.positionName}}&nbsp;&nbsp;&nbsp;&nbsp;[{{item.positionCity}}]</span>
                <span class="job-update-time">更新时间: {{item.updateDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
              </div>
              <div class="card-right">
                <span class="company-name">{{item.companyName}}</span>
                <span v-if="(!item.apply || item.apply === 1) && $store.get('user') && $store.get('user').roleName !== 'enterprise'" class="send-resume" @click.stop="relate('apply', item, 2)">
                  <i class="el-icon-s-promotion"></i>
                  <span class="publish-owner">{{item.userRealName ? item.userRealName : '--'}}</span>
                  <span class="send-resume-text" :title="'投递简历' + (item.userRealName ? ' ' + item.userRealName : '')">投递简历</span>
                </span>
                <span v-else-if="(item.apply && item.apply === 2) && $store.get('user').roleName !== 'enterprise'" class="has-sent-resume">简历已投递</span>
                <span v-else class="publish-owner-name"><span class="publish-owner">{{item.userRealName ? item.userRealName : '--'}}</span></span>

                <span v-if="(item.follow && item.follow === 2) && $store.get('user').roleName !== 'enterprise'" class="collection-state1" title="取消收藏" @click.stop="relate('follow', item, 1)"><i class="el-icon-star-on"></i></span>
                <span v-else-if="(item.follow && item.follow === 1) && $store.get('user').roleName !== 'enterprise'" class="collection-state0" title="收藏" @click.stop="relate('follow', item, 2)"><i class="el-icon-star-off"></i></span>
<!--                <span v-else class="collection-state1" title="取消收藏" @click="relate('follow', item.id, 1)"><i class="el-icon-star-on"></i></span>-->
              </div>
            </div>
            <div class="card-mid">
              <div class="card-left">
                <span class="job-salary">{{item.salaryDict ? item.salaryDict.dictName : '--'}}</span>
                <span class="work-experience">{{item.experienceDict ? item.experienceDict.dictName : '--'}}</span>
                <span class="education">{{item.academicDegreeDict ? item.academicDegreeDict.dictName : '--'}}</span>
                <span class="position-address" @click.stop="showMapHandle(item)"><i class="el-icon-location-outline"></i>{{item.positionAddress ? item.positionAddress : '--'}}</span>
              </div>
              <div class="card-right">
                <span class="company-type">互联网解决方案</span>
                <span class="financing-type">不需要融资</span>
                <span class="company-size">2000人以上</span>
              </div>
            </div>
            <div class="card-bottom">
              <div class="card-left" style="overflow: hidden;">
                <el-tag type="mini" v-for="(keywordItem, keywordItemIndex) of item.listLabel" :key="keywordItemIndex" v-if="item.listLabel" style="margin-right: 5px;">
                  {{keywordItem.labelName}}
                </el-tag>
              </div>
              <div class="card-right company-welfare">
<!--                <span title="年终奖，零食下午茶，节日福利，定期体检五险一金，股票特权，出国团结">年终奖，零食下午茶，节日福利，定期体检五险一金，股票特权，出国团结</span>-->
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <no-data class="job-wanted-content" v-else></no-data>
      <div class="job-wanted-cards-pagination" v-if="jobsData.length > 0">
<!--        <el-pagination-->
<!--          background-->
<!--          @current-change="handleCurrentChange"-->
<!--          layout="prev, pager, next"-->
<!--          :total="pageTotal">-->
<!--        </el-pagination>-->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[20, 50, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </div>

      <show-map v-if="showMap" :show-map-flag="showMap" :position-obj="positionObjForShowMap" @hideMap="showMap = false"></show-map>
    </div>
</template>

<script>
import ShowMap from '../ShowMap/ShowMap'
import NoData from '../NoData/NoData'

export default {
  name: 'JobWanted',
  components: {NoData, ShowMap},
  data () {
    return {
      searchKeyWord: '',
      showMap: false,
      positionObjForShowMap: null,
      pageTotal: 1000,
      filterParams: [],
      jobsData: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  methods: {
    searchJobs () {
      this.page.pageSize = 20
      this.page.pageNum = 1
      this.initDataSearch()
    },
    initDataSearch () {
      let pageNum = this.page.pageNum
      let pageSize = this.page.pageSize

      let searchParams = {}
      this.filterParams.forEach(item => {
        if (item.model) {
          searchParams[item.model.category.toLowerCase()] = item.model['dictNum']
        }
      })
      if (this.searchKeyWord.trim()) {
        searchParams['positionName'] = this.searchKeyWord.trim()
      }
      console.log(this.searchKeyWord)
      if (this.$store.get('user')) {
        this.$http.post(`${this.$api.getAllPosition.url}?pageNum=${pageNum}&pageSize=${pageSize}`, searchParams).then(_ => {
          if (_ && _.code === 200 && _.data && _.data.list) {
            this.jobsData = _.data.list || []
            this.page.pageSize = _.data.pageSize || this.page.pageSize
            this.page.pageNum = _.data.pageNum || this.page.pageNum
            this.page.total = _.data.total || this.page.total
          }
        }).catch(e => { console.log(e) })
      } else {
        this.$http.post(`${this.$api.getNewAllPositions.url}?pageNum=${pageNum}&pageSize=${pageSize}`, searchParams).then(_ => {
          if (_ && _.code === 200 && _.data && _.data.list) {
            this.jobsData = _.data.list || []
            this.page.pageSize = _.data.pageSize || this.page.pageSize
            this.page.pageNum = _.data.pageNum || this.page.pageNum
            this.page.total = _.data.total || this.page.total
          }
        }).catch(e => { console.log(e) })
      }
    },
    handleCurrentChange (val) {
      console.log(val)
      this.page.pageNum = val
      this.initDataSearch()
    },
    handleSizeChange (val) {
      console.log(val)
      this.page.pageSize = val
      this.initDataSearch()
    },
    filterWithParams (filterItemObj) {
      this.page.pageSize = 20
      this.page.pageNum = 1
      filterItemObj.item.model = filterItemObj.filterItem.content !== '不限' ? filterItemObj.filterItem : null
      this.initDataSearch()
    },
    deleteFilterParam (item) {
      item.model = null
      // let searchParams = {}
      // this.filterParams.forEach(item => {
      //   if (item.model) {
      //     searchParams[item.model.category.toLowerCase()] = item.model['dictNum']
      //   }
      // })
      this.initDataSearch()
    },
    clearFilterParams () {
      this.page.pageSize = 20
      this.page.pageNum = 1
      this.searchKeyWord = ''
      this.filterParams.forEach(item => {
        item.model = null
      })
      this.initDataSearch()
    },
    relate (relationType, position, val) {
      let p = {
        positionId: position.id
      }
      if (relationType === 'follow') {
        p['follow'] = val
        p['apply'] = position.apply || 1
      }
      if (relationType === 'apply' && val === 2) {
        p['follow'] = position.follow || 1
        p['apply'] = val

        this.$confirm('投递简历后，企业将获取到您的个人信息，是否继续?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        }).then(() => {
          this.$http.post(this.$api.createOrUpdateRelation.url, p).then(_ => {
            if (_ && _.code === 200) {
              position.apply = val
              this.$message.success('简历已投递')
            }
            console.log(_)
          }).catch(e => {
            console.log(e)
          })
        }).catch(e => {
          console.log(e)
        })
        return false
      }

      this.$http.post(this.$api.createOrUpdateRelation.url, p).then(_ => {
        if (_ && _.code === 200) {
          position.follow = val
          if (relationType === 'follow' && val === 2) {
            this.$message.success('收藏成功')
          }
          if (relationType === 'follow' && val === 1) {
            this.$message.success('取消收藏成功')
          }
          if (relationType === 'apply' && val === 2) {
            this.$message.success('简历投递成功，招聘人员会对您的简历进行筛选')
          }
        }
        console.log(_)
      }).catch(e => {
        console.log(e)
      })
    },
    showMapHandle (item) {
      if (!item.location) {
        this.$alert('该职位暂无地图信息！', '提示', {type: 'warning'})
        return false
      }

      this.showMap = true
      this.positionObjForShowMap = item
    },
    goJobDetailPage (position) {
      let routeData = this.$router.resolve({
        path: `/job-detail`,
        query: {
          positionId: position.id
        }
      })
      window.open(routeData.href, '_blank')
    },
    sortFilterParams () {
      let sortArr = ['工作经验', '学历要求', '薪资要求', '融资阶段', '公司规模']
      this.filterParams.sort(this.compare(sortArr, 'name'))
    },
    compare (sortArr, prop) {
      return (a, b) => {
        return sortArr.indexOf(a[prop]) - sortArr.indexOf(b[prop])
      }
    }
  },
  mounted () {
    this.searchKeyWord = this.$route.query.key || ''
    this.initDataSearch()

    // 工作经验下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'EXPERIENCE'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.filterParams.push({
          name: '工作经验',
          model: null,
          filterList: _.data
        })
      }
      this.sortFilterParams()
    })
    // 学历下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'EDUCATION'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.filterParams.push({
          name: '学历要求',
          model: null,
          filterList: _.data
        })
      }
      this.sortFilterParams()
    })
    // 薪资下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'SALARY'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.filterParams.push({
          name: '薪资要求',
          model: null,
          filterList: _.data
        })
      }
      this.sortFilterParams()
    })
    // 融资阶段下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'FINANCING'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.filterParams.push({
          name: '融资阶段',
          model: null,
          filterList: _.data
        })
      }
      this.sortFilterParams()
    })
    // 公司规模下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'SCALE'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.filterParams.push({
          name: '公司规模',
          model: null,
          filterList: _.data
        })
      }
      this.sortFilterParams()
    })
  }
}
</script>

<style scoped>
  .job-wanted-search {
    /*position: fixed;*/
    margin: auto;
    width: 100%;
    background: #f4f4f4;
    padding: 10px 0;
  }
  .input-with-select /deep/ .el-input-group__append {
    border-color: #409EFF;
  }

  .input-with-select button {
    background: #409EFF;
    color: #fff;
    border-radius: 0;
    cursor: pointer;
  }

  .input-with-select:active {
    background: #ffffff;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    color: #409EFF;
  }
.job-wanted-content {
  width: 1200px;
  margin: auto;
  text-align: left;
  min-height: calc(100vh - 245px);
}

  .job-wanted-cards {
    margin-bottom: 12px;
    cursor: pointer;
  }

  .job-wanted-cards-pagination {
    width: 1200px;
    margin: auto auto 10px;
    text-align: right;
  }
  .filter-tool {
    width: 1200px;
    margin: auto;
    text-align: left;
    padding-top: 10px;
  }
  .filter-item {
    width: 130px;
    display: inline-block;
  }
  .el-dropdown-link {
    cursor: pointer;
    outline: none;
  }
  .el-dropdown-link:hover{
    color: #409EFF;
  }
  .clear-filter-params {
    float: right;
    text-align: right;
    color: #666666;
    cursor: pointer;
  }

  .el-icon-caret-bottom {
    margin-left: 20px;
  }
  .card-mid {
    margin-top: 10px;
  }
  .card-bottom {
    border-top: 1px dashed #cccccc;
    margin-top: 10px;
    padding-top: 10px;
    white-space: nowrap;
  }
  .card-left, .card-right {
    display: inline-block;
  }
  .card-left {
    width: 65%;
  }
  .card-right {
    width: calc(35% - 100px);
  }
  .job-name-city, .company-name {
    color: #409EFF;
    font-size: 18px;
  }
  .job-update-time {
    color: #666666;
    font-size: 13px;
    margin-left: 30px;
  }
  .send-resume, .has-sent-resume {
    margin-left: 10px;
    border: 1px solid #cccccc;
    border-radius: 50px;
    padding: 2px 10px;
  }
  .publish-owner-name {
    margin-left: 10px;
    border: 1px solid #cccccc;
    border-radius: 50px;
    padding: 2px 10px;
  }
  .has-sent-resume {
    color: #ffffff;
    background: #409eff;
    border-color: #409eff;
  }
  .el-icon-s-promotion {
    color: #409EFF;
  }
  .send-resume-text {
    font-size: 13px;
    display: none;
  }
  .publish-owner {
    color: #666666;
    font-size: 13px;
    display: inline-block;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 14px;
    height: 12px;
  }
  .send-resume:hover .publish-owner {
    display: none;
  }
  .send-resume:hover .send-resume-text {
    display: inherit;
  }
  .send-resume:hover .el-icon-s-promotion {
    color: #ffffff;
  }
  .send-resume:hover {
    border-color: #409EFF;
    background: #409EFF;
    color: #ffffff;
  }
  .job-salary {
    font-size: 16px;
    font-weight: 400;
    color: #fc703e;
  }
  .work-experience, .education, .position-address {
    color: #666666;
    position: relative;
    padding: 0 15px;
  }
  .position-address:hover {
    color: #409EFF;
    text-decoration: underline;
  }
  .education::before, .position-address::before, .financing-type::before, .company-size::before {
    position: absolute;
    content: '';
    width: 1px;
    height: 12px;
    background: #cccccc;
    left: 0;
    top: 1px;
  }
  .company-type, .financing-type, .company-size {
    position: relative;
    color: #666666;
    padding-right: 10px;
  }
  .financing-type, .company-size {
    padding-left: 10px;
  }
  .company-welfare {
    width: 35%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #666666;
  }
  .collection-state0, .collection-state1 {
    font-size: 18px;
    color: rgb(247, 186, 42);
    margin-left: 20px;
  }
  .collection-state1 {
    font-size: 20px;
  }
  .el-card {
    box-shadow: none;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/JobWanted/JobWanted.vue